// src/pages/OauthCallback.jsx
import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function OauthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = hashParams.get("access_token");

    if (accessToken) {
      console.log(" Extracted access_token:", accessToken);

      axios
        .post("http://localhost:5000/auth/google", { access_token: accessToken }) 
        .then((res) => {
          console.log("Google Login Success:", res.data);
          const { token, user } = res.data;

          
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));

          
          window.location.href = "/dashboard";
        })
        .catch((err) => {
          console.error("❌ Google login failed:", err.response?.data || err.message);
          alert("Google login failed.");
          navigate("/sign-in");
        });
    } else {
      console.error("❌ No access_token found in URL.");
      alert("Google login failed - missing token.");
      navigate("/sign-in");
    }
  }, [navigate]);

  return <div>Authenticating with Google...</div>;
}

export default OauthCallback;
